import { HeaderMode } from '../../table-header/enums/HeaderMode';
import { GridState, GridStateActions, GridEvent, GridNotification, NotificationData } from './grid-state.interface';

/**
 * Selection State - When one or more rows are selected
 */
export class SelectionState implements GridState {
  getMode(): HeaderMode {
    return HeaderMode.Selection;
  }

  onEnter(actions: GridStateActions): void {
    actions.disableInlineEditing();
  }

  onExit(actions: GridStateActions, event: GridEvent): void {
    actions.enableInlineEditing();
  }

  canTransitionTo(event: GridEvent): HeaderMode | null {
    switch (event) {
      case 'DESELECT':
        return HeaderMode.Idle;
      case 'DUPLICATE':
        return HeaderMode.Duplication;
      default:
        return null;
    }
  }

  handleNotification(notification: GridNotification, data: NotificationData, actions: GridStateActions): GridEvent | null {
    switch (notification) {
      case 'ROW_SELECTION_CHANGED':
        if (data.selectedCount === 0 && !data.hasEdits && !data.hasDuplicates) {
          return 'DESELECT';
        }
        return null;

      case 'SELECTION_CLEARED':
        if (data.selectedCount === 0) {
          return 'DESELECT';
        }
        return null;

      case 'DATASET_CHANGED':
        if (data.dataset && data.selectedIds && data.selectedIds.length > 0) {
          const datasetIds = new Set(data.dataset.map((item: any) => item.id));
          const hasInvalidSelection = data.selectedIds.some(id => !datasetIds.has(id));

          if (hasInvalidSelection) {
            return 'DESELECT';
          }
        }
        return null;
      default:
        return null;
    }
  }

  getDataToSave(context: { duplicatedRows: any[]; editedRows: Map<number, any> }): any[] {
    return [];
  }
}
